// <div data-controller="pay--checkout">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import * as helpers from "@/utils/helpers";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [
      "form",
      "product",
      "productNameLabel",
      "productPriceLabel",
      "pg",
      "loading",
      "submit"
  ];
  static classes = [ "" ]
  static values = {
    impUid: String,
    customerUid: String,
    customerEmail: String,
    customerName: String,
    itemType: String,
    redirectUrl: String,
    prepareUrl: String,
    confirmUrl: String,
    validateUrl: String,
    productData: Object,
  };

  initialize() {

  }

  get creditsChargeModalController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("creditsChargeModal"), "components--modal")
  }

  get product() {
    if (this.productTarget.value) {
      return this.productDataValue[this.productTarget.value];
    }
  }

  showModal() {
    if (this.product) {
      this.productNameLabelTarget.innerText = this.product.name;
      this.productPriceLabelTarget.innerText = helpers.krw(this.product.price);

      if (this.creditsChargeModalController) {
        this.creditsChargeModalController.showModal();
      }
    } else {
      this.productTarget.reportValidity();
    }
  }

  loadScript = (callback) => {
    const impId = this.impUidValue;

    if (window.IMP) {
      IMP.init(impId);
      callback(IMP);
    } else {
      appendScript("https://code.jquery.com/jquery-1.12.4.min.js", () => {
        appendScript("https://cdn.iamport.kr/v1/iamport.js", () => {
          IMP.init(impId);
          callback(IMP);
        });
      });
    }
  }

  get currentPg() {
    let checkedPg;
    this.pgTargets.forEach((target) => {
      if (target.checked) {
        checkedPg = target.value;
      }
    });
    return checkedPg;
  }

  toggleSubmit(submitting) {
    this.isProcessing = submitting;

    if (this.hasSubmitTarget) {
      if (submitting) {
        this.submitTarget.innerText = "로딩 중.."
      } else {
        this.submitTarget.innerText = "결제하기"
      }

      this.submitTarget.disabled = submitting;
    }
  }

  startPaymentRequest(e) {
    // 이미 진행 중이면 중복 실행 막기
    if (this.isProcessing) return;
    this.toggleSubmit(true)

    if (this.formTarget.checkValidity()) {
      this.loadScript((iamport) => {

        api.post(this.prepareUrlValue, {
          prepare_item_type: this.itemTypeValue,
          prepare_data: {
            charging_credits: this.productTarget.value
          }
        }).then((response) => {
          const merchant_uid = response.data.merchant_uid;

          const params = {
            pg: this.currentPg,
            pay_method: 'card',
            merchant_uid: merchant_uid,
            name: this.product.name,
            amount: this.product.price,
            buyer_email: this.customerEmailValue,
            buyer_name: this.customerNameValue,
            m_redirect_url: this.redirectUrlValue,
            notice_url: this.confirmUrlValue
          }

          iamport.request_pay(params, this.waitAndRedirect);
        }).catch((err) => {
          alert(err)
          // 에러 발생 시 플래그 리셋 및 버튼 활성화
          this.toggleSubmit(false);
        })
      });
    } else {
      this.formTarget.reportValidity();
      this.toggleSubmit(false);
    }
  }

  waitAndRedirect = (response) => {
    if (!response.success) {
      alert("결제가 정상적으로 진행되지 않았습니다. 다시 시도해주세요.");
      this.toggleSubmit(false);
      return;
    }

    const imp_uid = response.imp_uid;
    const MAX_RETRIES = 15;
    const RETRY_INTERVAL = 2000;

    let retryCount = 0;

    this.loadingTarget.style.display = "flex";

    const poll = () => {
      api.post(this.validateUrlValue, { imp_uid: imp_uid })
          .then((res) => {
            if (res.data.valid) {
              window.location.reload();
            } else if (retryCount < MAX_RETRIES) {
              retryCount += 1;
              setTimeout(poll, RETRY_INTERVAL);
            } else {
              this.loadingTarget.style.display = "none";
              alert("결제 처리 시간이 초과되었습니다. 다시 시도해주세요.");
              window.location.reload();
            }
          })
          .catch((err) => {
            console.error("결제 확인 중 오류", err);
            this.loadingTarget.style.display = "none";
            alert("결제 확인 중 문제가 발생했습니다. 다시 시도해주세요.");
            window.location.reload();
          });
    };

    poll();
  };

  connect() {
  }

  disconnect() {

  }
}